<template src="./BusSelection.html"></template>

<script>
import { getVehicles } from '@/services/vehicle'
import { getBookedSeats } from '@/services/passenger'
import { getRoute } from '@/services/routes'
import { format } from 'date-fns'

export default {
  name: 'BusSelection',
  data () {
    return {
      queryParams: {},
      selectedSeats: [],
      vehicles: [],
      takenSeats: [],
      locationRoute: {
        sections: []
      },
      loaded: false,
      dontProceed: true,
      showSeatings: false,
      seatsAvailable: new Array(7).fill(false),
      selectedSection: '',
      routeSection: {},
      isSectionSoldOut: false,
      soldOutSectionKey: -1
    }
  },
  computed: {
    maxCheck () {
      return parseInt(this.queryParams.passengers)
    },
    depatureDate () {
      return format(new Date(parseInt(this.$route.query.departure_date)))
    },

    hasSections () {
      return this.locationRoute.sections.length > 0
    }
  },

  watch: {
    '$route' (to, from) {
      // TODO dont allow user to manipulate the route
    },

    selectedSeats (newVal) {
      this.dontProceed = !(newVal.length >= 1)
    }
  },

  mounted () {
    this.queryParams = { ...this.$route.query }
    this.loadVehicles()
    this.loadRoute(this.queryParams.loc_route)
  },

  methods: {
    handleSelectedSection (value) {
      // reset the selected seats for any section
      this.selectedSeats = []
      this.seatsAvailable = new Array(7).fill(false)
      const routeSections = this.locationRoute.sections
      for (let i of routeSections) {
        if (i.section === value) {
          this.routeSection = i
          break
        }
      }
      this.loadBookedSeats()
    },

    loadRoute (id) {
      getRoute(id)
        .then(res => {
          this.locationRoute = res.data
          // check if this route has available seats
          const sections = res.data.sections || []
          this.locationRoute.sections = sections
          if (sections && sections.length > 0) {
            // by default set the routeSection|selectedSection to the first one
            this.routeSection = sections[0]
            this.selectedSection = sections[0].section
          }
          this.loadBookedSeats()
        })
    },

    validateSeatSelection () {
      if (this.selectedSeats.length < this.queryParams.passengers) {
        this.$message({
          type: 'warning',
          message: 'Please select seat for all passengers'
        })
        return true
      }
      return false
    },

    loadVehicles () {
      getVehicles()
        .then(res => {
          this.vehicles = res.data
        })
        .catch(() => {

        })
    },
    hookPageBeforeRouteEnter () {},

    handleProceedCheckout () {
      if (this.validateSeatSelection()) {
        return null
      }
      let queryParams = {
        ...this.$route.query,
        selectedSeats: this.selectedSeats.join(',')
      }
      if (this.routeSection) {
        queryParams = {
          ...queryParams,
          route_section: this.routeSection.key
        }
      }
      this.$router.push({
        name: 'Checkout',
        query: { ...queryParams }
      })
    },

    mapBookedSeatsToAvailable (seats, sectionKey) {
      for (const s of seats) {
        if (s !== 7) { this.seatsAvailable[s - 1] = true }
      }
      this.isSectionSoldOut = !this.seatsAvailable.includes(false)
      if (this.isSectionSoldOut) {
        this.soldOutSectionKey = sectionKey
      }
      if (this.locationRoute.blocked) {
        // TODO block this also on backend level
        this.seatsAvailable = this.seatsAvailable.map(s => (true))
      }
    },

    gotoBooking () {
      this.$router.push('/')
    },

    loadBookedSeats () {
      this.loaded = false
      let bySection = ''
      if (this.routeSection) {
        // query booked seat by route sections if this
        // route has sections
        bySection = `&route_section=${this.routeSection.key}`
      }
      getBookedSeats(this.queryParams.loc_route, this.depatureDate, bySection)
        .then((res) => {
          this.loaded = true
          // always set seat 7 as selected
          this.seatsAvailable[6] = true
          this.mapBookedSeatsToAvailable(res.data.taken_seats, this.routeSection.key)
        })
    }
  }
}
</script>

<style lang="scss" src="./bus-selection.scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/home/BusSelection.vue